import React, { useState } from 'react';
import { Check, X, ArrowRight, Clock, Target, Shield, BarChart3, Users, Layers, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
export function AdvantageProduct() {
  const [isPartialCampaign, setIsPartialCampaign] = useState(false);
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-363">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-364">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-365" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-366">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-367">
            Flagship Partnership
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-368">
            HIRE Advantage
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-369">
            Recruiting stops being a scramble when someone owns the system — not
            just the traffic.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-370">
            HIRE Advantage is the partnership where recruiting becomes
            consistent, predictable, and scalable.
          </p>
        </motion.div>
      </section>

      {/* 2. PROBLEM REFRAME */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-371">
        <div className="text-center mb-12" data-id="element-372">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-373">
            The Real Problem
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-374">
            Most companies don't fail at finding candidates. They fail at system
            execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-375">
          <div className="bg-slate-900/30 border border-slate-800 p-8 rounded-xl" data-id="element-376">
            <h3 className="text-sm text-rose-400 uppercase tracking-widest font-bold mb-6" data-id="element-377">
              System Failures
            </h3>
            <ul className="space-y-4" data-id="element-378">
              {['Inconsistent interviews', 'Drifting hiring standards', 'Early churn discovered too late', 'Leaders relying on gut decisions'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-379">
                  <X className="w-5 h-5 text-rose-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-380" />
                  <span className="line-through opacity-70" data-id="element-381">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center p-8" data-id="element-382">
            <p className="text-xl text-white font-medium mb-4" data-id="element-383">
              Advantage solves the system failure, not just the talent shortage.
            </p>
            <p className="text-slate-400" data-id="element-384">
              We replace guesswork with infrastructure and accountability.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT ADVANTAGE IS */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-385">
        <div className="max-w-5xl mx-auto" data-id="element-386">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-387">
            <div data-id="element-388">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-389">
                Full System Ownership
              </h2>
              <div className="space-y-4 text-slate-400 mb-8" data-id="element-390">
                <p data-id="element-391">This is not lead generation.</p>
                <p data-id="element-392">This is not outsourced recruiting.</p>
                <p data-id="element-393">This is full ownership of the recruiting system.</p>
              </div>
              <div className="p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-394">
                <p className="text-[#7FE0C3] font-medium" data-id="element-395">
                  HIRE Advantage is the only partnership level where HIRE is
                  accountable for the recruiting system actually working.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-396">
              <div className="flex items-start" data-id="element-397">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-398">
                  <Shield className="w-6 h-6 text-[#7FE0C3]" data-id="element-399" />
                </div>
                <div data-id="element-400">
                  <h3 className="text-white font-bold mb-2" data-id="element-401">Accountability</h3>
                  <p className="text-slate-400 text-sm" data-id="element-402">
                    We don't just deliver leads; we own the outcome of the
                    system's performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-403">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-404">
                  <Target className="w-6 h-6 text-[#7FE0C3]" data-id="element-405" />
                </div>
                <div data-id="element-406">
                  <h3 className="text-white font-bold mb-2" data-id="element-407">Consistency</h3>
                  <p className="text-slate-400 text-sm" data-id="element-408">
                    Eliminating the variance between good weeks and bad weeks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 10-STEP SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-409">
        <div className="text-center mb-12" data-id="element-410">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-411">
            The 10-Step Recruiting System
          </h2>
          <p className="text-slate-400" data-id="element-412">
            Every HIRE Advantage partner runs the same system. The difference is
            who owns it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-413">
          {['Attract', 'Engage', 'Screen', 'Qualify', 'Commit', 'Schedule', 'Launch', 'Integrate', 'Train', 'Retain'].map((step, idx) => <div key={idx} className="bg-slate-900/40 border border-slate-800 p-6 rounded-lg text-center hover:border-[#7FE0C3]/30 transition-colors group" data-id="element-414">
              <div className="text-xs text-slate-500 mb-2 font-mono" data-id="element-415">
                0{idx + 1}
              </div>
              <div className="text-white font-medium group-hover:text-[#7FE0C3] transition-colors" data-id="element-416">
                {step}
              </div>
            </div>)}
        </div>
      </section>

      {/* 5. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-417">
        <div className="max-w-6xl mx-auto" data-id="element-418">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-419">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-420">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 relative overflow-hidden" data-id="element-421">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-422" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-423">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-424" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-425">
                {['Recruiting system architecture (custom ATS)', 'Traffic, screening, and qualification standards', 'Hiring consistency and interview structure', 'Sales School and launch readiness', 'Early performance tracking and correction', 'Ongoing optimization and accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-426">
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-427" />
                    <span data-id="element-428">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-429">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-430" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-431">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-432" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-433">
                {['Final hiring decisions', 'Day-to-day sales leadership', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-434">
                    <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-435">
                      <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-436" />
                    </div>
                    <span data-id="element-437">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. TIMELINE */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-438">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-439">
          Partnership Timeline
        </h2>

        <div className="relative" data-id="element-440">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-slate-800 -translate-x-1/2 hidden md:block" data-id="element-441" />

          <div className="space-y-12" data-id="element-442">
            {[{
            days: 'Days 1–21',
            title: 'Build & Launch',
            items: ['System architecture build', 'Campaign launch', 'Sales School setup', 'First candidates generated']
          }, {
            days: 'Weeks 4–12',
            title: 'Support & Consulting',
            items: ['Weekly support and consulting', 'Establishing strong baseline KPIs', 'Interviewing 30+ triple screened prospects/mo', 'Hiring 15+ people/mo']
          }, {
            days: 'Month 3+',
            title: 'Optimization',
            items: ['Increase conversion rates', 'Improve retention', 'Maximize ROI', 'Scale successful patterns']
          }].map((phase, idx) => <div key={idx} className={`flex flex-col md:flex-row items-center ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-443">
                <div className="w-full md:w-1/2 p-4 md:p-8" data-id="element-444">
                  <div className={`bg-slate-900/30 border border-slate-800 p-6 rounded-xl ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-445">
                    <div className="text-[#7FE0C3] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-446">
                      {phase.days}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-4" data-id="element-447">
                      {phase.title}
                    </h3>
                    <ul className={`space-y-2 ${idx % 2 === 0 ? '' : 'md:flex md:flex-col md:items-end'}`} data-id="element-448">
                      {phase.items.map((item, i) => <li key={i} className="text-slate-400 text-sm flex items-center" data-id="element-449">
                          {idx % 2 !== 0 && <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-slate-700 ml-2 order-2" data-id="element-450" />}
                          <span className={idx % 2 !== 0 ? 'md:mr-0' : ''} data-id="element-451">
                            {item}
                          </span>
                          {(idx % 2 === 0 || window.innerWidth < 768) && <span className="w-1.5 h-1.5 rounded-full bg-slate-700 ml-2 md:ml-0 md:mr-2 md:order-first" data-id="element-452" />}
                        </li>)}
                    </ul>
                  </div>
                </div>
                <div className="w-8 h-8 rounded-full bg-slate-900 border-4 border-slate-800 z-10 hidden md:block" data-id="element-453" />
                <div className="w-full md:w-1/2" data-id="element-454" />
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. PRICING */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-455">
        <div className="max-w-6xl mx-auto" data-id="element-456">
          <div className="text-center mb-12" data-id="element-457">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-458">
              Partnership Pricing
            </h2>
            <p className="text-slate-400" data-id="element-459">
              Recruiting stops being a scramble when someone owns the system —
              not just the traffic.
            </p>
          </div>

          <div className="flex justify-center mb-12" data-id="element-460">
            <div className="bg-slate-900/50 p-1 rounded-lg border border-slate-800 flex items-center" data-id="element-461">
              <button onClick={() => setIsPartialCampaign(false)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${!isPartialCampaign ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-462">
                Full Campaign
              </button>
              <button onClick={() => setIsPartialCampaign(true)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${isPartialCampaign ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-463">
                Partial Campaign
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-464">
            {/* Build Fee */}
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-465">
              <div className="mb-4" data-id="element-466">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-467">
                  Build (One-Time)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-468">$5,000</div>
                <div className="mt-4 inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold" data-id="element-469">
                  <Shield className="w-3 h-3 mr-1.5" data-id="element-470" />
                  Money Back Guarantee
                </div>
              </div>
            </div>

            {/* Monthly Total */}
            <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-471">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-472" />
              <div className="mb-4" data-id="element-473">
                <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-474">
                  Total Monthly
                </div>
                <div className="text-4xl font-bold text-white mb-1" data-id="element-475">
                  ${isPartialCampaign ? '3,750' : '5,000'}
                </div>
                <div className="text-sm text-slate-500 mb-6" data-id="element-476">/ month</div>

                <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-477">
                  <div className="flex justify-between text-sm" data-id="element-478">
                    <span className="text-slate-400" data-id="element-479">System Fee</span>
                    <span className="text-white font-medium" data-id="element-480">$2,500</span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-481">
                    <span className="text-slate-400" data-id="element-482">
                      {isPartialCampaign ? 'Partial' : 'Full'} Campaign
                    </span>
                    <span className="text-white font-medium" data-id="element-483">
                      ${isPartialCampaign ? '1,250' : '2,500'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Performance Bonuses */}
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-484">
              <div className="mb-4" data-id="element-485">
                <div className="text-xs text-amber-400 uppercase tracking-widest mb-4" data-id="element-486">
                  Performance Bonuses
                </div>
                <ul className="space-y-3" data-id="element-487">
                  <li className="flex items-start" data-id="element-488">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-489">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-490">
                      per rep at launch
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-491">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-492">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-493">
                      per rep at 30 days
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-494">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-495">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-496">
                      per rep at 60 days
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-497">
                    <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-498">
                      $250
                    </span>
                    <span className="text-slate-300 text-lg" data-id="element-499">
                      per rep at 90 days
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-500">
            <p className="text-[#7FE0C3] text-center font-medium" data-id="element-501">
              Bonuses are only paid when reps reach real performance milestones.
            </p>
          </div>
        </div>
      </section>

      {/* 8. WHO THIS IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-502">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-503">
          <div data-id="element-504">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-505">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-506" />
              This is for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-507">
              {['Want recruiting to actually work', 'Value consistency over heroics', 'Are open to better systems', 'Want a partner, not a vendor'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-508">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-509" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-510">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-511">
              <X className="w-5 h-5 text-rose-500 mr-2" data-id="element-512" />
              This is not for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-513">
              {['Only want resumes', "Aren't open to process", 'Want zero accountability'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-514">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-3 mt-2" data-id="element-515" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 9. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-516">
        <div className="max-w-3xl mx-auto" data-id="element-517">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-518">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-519">
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-520">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-521">
                Infrastructure
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-522">Edge</h3>
              <p className="text-slate-400 text-sm" data-id="element-523">
                Exists for infrastructure-only needs.
              </p>
            </div>
            <div className="flex-1 p-6 border border-[#7FE0C3]/30 rounded-lg bg-slate-800/30" data-id="element-524">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-525">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-526">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-527">
                The foundation that makes both work.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-528">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-529">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-530">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-531">
                Exists when execution capacity is the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. CTA */}
      <section className="py-32 px-6 md:px-12 text-center" data-id="element-532">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-533">
          Ready to make recruiting predictable?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-534">
          Let's see if Advantage is the right fit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-535" />
        </button>
      </section>
    </div>;
}